export default __webpack_public_path__ + "static/media/1_2.440aa268.png";